<template>
    <section class="location">
      <div class="location__content container">
        <h1 class="location__title">
            <b>April 24-26, 2023</b><br>
            La Concha Resort, San Juan, Puerto Rico
        </h1>
        <div class="location__card-container">
            <div class="card">
                <img src="../assets/location/Icon1.svg" alt="">
                <h3 class="card__title">
                    <b>40+</b><br>
                    Public Company Presentations
                </h3>
                <p class="card__description">Attend a wide variety of industry panels, hosted by innovative company leaders. </p>
            </div>
            <div class="card">
                <img src="../assets/location/Icon2.svg" alt="">
                <h3 class="card__title">
                    <b>500</b><br>
                    Attendees
                </h3>
                <p class="card__description">This in-person summit is the year’s can’t miss event.</p>
            </div>
            <div class="card">
                <img src="../assets/location/Icon3.svg" alt="">
                <h3 class="card__title">
                    <b>Thousands</b><br>
                    of Investors Invited
                </h3>
                <p class="card__description">Network with the best investment community in the world, while enjoying  the gorgeous tropical location and nightly entertainment.</p>
            </div>
        </div>
      </div>
    </section>
  </template>
  
  <style lang="scss" scoped>
    @import '@/styles/components/location.scss';
  </style>
  
  <script>

  export default {
    name: 'location',
    components: {
      
    },
    data() {
      return {
      };
    },
  };
  </script>